import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'empty',
})
export class EmptyPipe implements PipeTransform {
  transform(value: unknown): unknown {
    if (value === '' || value === null || value === undefined) {
      return '⸺';
    }
    return value;
  }
}
